import { ApiService } from '../../service/api/ApiService'

/**
 * @type {string} Endpoint получения всех компаний
 */
const allInvitesEndpoint = '/personal-cabinet/invite/'

/**
 * Метод получающий компании.
 *
 * @param context Стейт
 * @returns {Promise<null|*>}
 */
const findAllInvitesByAuthUser = async (context) => {
  context.commit('fetchInvites')
  try {
    const response = await ApiService.get(allInvitesEndpoint)
    context.commit('fetchInvitesSuccess', response.data.data)
    return response.data.data
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('fetchInvitesError', error)
    return null
  }
}

export default {
  findAllInvitesByAuthUser,
}
